import {
  getActiveMonth,
  getActiveYear,
} from '../../../../../shared/utils/pure-functions/dates';

import { LeadsBenchmarkGeneralActionTypes } from './constants';

export const general = (state, action) => {
  switch (action.type) {
    case LeadsBenchmarkGeneralActionTypes.GET_DATA_REQUEST_BEGIN:
      return {
        ...state,
        selectedMonth: getActiveMonth(action.data),
        selectedYear: getActiveYear(action.data),
        selectedDate: action.data,
      };
    default:
      return state;
  }
};
